<template>
  <div>
    <van-icon name="wap-nav" size="40" class="menu" @click="show = true" />
    <van-popup v-model="show" position="left" class="menu-popup">
      <div v-for="route in permission_routes">
        <van-cell
          v-if="hasOneShowingChild(route.children, route) && (!onlyOneChild.children || onlyOneChild.noShowingChildren) && !route.alwaysShow && onlyOneChild.meta"
          :title="onlyOneChild.meta.title" is-link :to="resolvePath(onlyOneChild.path, route.path)"
          @click="show = false" />
        <van-cell v-else v-for="child in route.children" :key="resolvePath(child.path, route.path)"
          :title="child.meta.title" is-link :to="resolvePath(child.path, route.path)" @click="show = false" />
      </div>
    </van-popup>
  </div>
</template>

<script>
  import {
    Icon,
    Popup,
    Cell,
    CellGroup,
    Collapse,
    CollapseItem
  } from 'vant';
  import {
    mapGetters
  } from 'vuex';
  import {
    isExternal
  } from '@/utils/validate'
  import path from 'path'
  export default {
    name: 'sidebar',
    components: {
      [Popup.name]: Popup,
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [Collapse.name]: Collapse,
      [CollapseItem.name]: CollapseItem,
      [Icon.name]: Icon
    },
    data() {
      this.onlyOneChild = null
      return {
        show: false,
      };
    },
    computed: {
      ...mapGetters([
        'permission_routes',
        'sidebar'
      ]),
    },
    methods: {
      hasOneShowingChild(children = [], parent) {
        const showingChildren = children.filter(item => {
          if (item.hidden) {
            return false
          } else {
            // Temp set(will be used if only has one showing child)
            this.onlyOneChild = item
            return true
          }
        })

        // When there is only one child router, the child router is displayed by default
        if (showingChildren.length === 1) {
          return true
        }

        // Show parent if there are no child router to display
        if (showingChildren.length === 0 && !parent.hidden) {
          this.onlyOneChild = {
            ...parent,
            path: '',
            noShowingChildren: true
          }
          return true
        }

        return false
      },
      resolvePath(routePath, basePath) {
        if (isExternal(routePath)) {
          return routePath
        }
        if (isExternal(basePath)) {
          return basePath
        }
        return path.resolve(basePath, routePath)
      }
    },
  }
</script>

<style scoped>
  .menu {
    position: fixed;
    left: 15px;
    bottom: 15px;
  }

  /deep/ .menu-popup .van-cell {
    background-color: transparent;
  }

  .menu-popup {
    width: 35%;
    height: 100vh;
    background-image: linear-gradient(-225deg, #E3FDF5 0%, #FFE6FA 100%);
  }
</style>


// WEBPACK FOOTER //
// src/layout/sidebar.vue